import s from './PromoRoll.module.sass'
import React, { FC } from 'react'
import { useAppSelector } from '@app/model/store'
import { PromoRollCard } from 'src/4_features/PromoRoll/ui/PromoRollCard'
import { Carousel } from '@shared/ui/Layout/Carousel'
import { ContainerLongCenter } from '@shared/ui/Layout/Containers/ContainerLongCenter'
import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import Skeleton from '@features/PromoRoll/Skeleton'
import { allPromoData } from '@features/PromoRoll/consts/allPromoData'
import { TypePromoIds } from '@features/PromoRoll/types/types'
import CalendarArrow from '@widgets/Restaurant/RestConcerts/ui/CalendarArrow/CalendarArrow'

interface Props {
  promoIds: TypePromoIds
  className?: string
  loading?: boolean
}

// TODO: разобраться почему серверный компонент и клиентский, при включении shuffle начинают выдавать ошибку
const shuffledArr = (array) => {
  return array.length > 0
    ? array
        .map((value) => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value)
    : null
}

const PromoRoll: FC<Props> = ({ promoIds, className = '' }) => {
  const storeLoadedState = useAppSelector((state) => state.global.storeLoaded)

  if (!storeLoadedState) return <Skeleton className={className} />
  if (!promoIds.length && !storeLoadedState) return

  return (
    <ErrorBoundary>
      <ContainerLongCenter classNameContent={s.content} classNameContainer={`${className} ${s.wrapper}`}>
        <div className={s.promo}>
          {!!promoIds.length && (
            <Carousel>
              <div className={s['slider-controls']}>
                <Carousel.Arrow direction='prev' hideDisabled={true}>
                  <CalendarArrow state='prev' hasOverlay={false} hasButton={true} />
                </Carousel.Arrow>

                <Carousel.Arrow direction='next' hideDisabled={true}>
                  <CalendarArrow state='next' hasOverlay={false} hasButton={true} />
                </Carousel.Arrow>
              </div>

              <Carousel.Slider shadow={true}>
                {promoIds.map((id, index) => (
                  <PromoRollCard key={id} data={allPromoData[id]} analytic={{ section_index: index }} />
                ))}
              </Carousel.Slider>
            </Carousel>
          )}
        </div>
      </ContainerLongCenter>
    </ErrorBoundary>
  )
}

export default PromoRoll
